<div class="business-stage-phase-stats w-full card-bg duration-200 rounded-lg p-4 relative">
  <!-- Header with Title and Toggle -->
  <div class="flex items-center justify-between mb-6">
    <h2 class="text-lg font-medium text-[#141437] dark:text-white">{{ title }}</h2>
    
    <app-toggle-btns
      [headerOptions]="{ showlabels: true, showIcon: true, showToggleButton: true, toggleOptions: toggleOptions, showTable: view === 'table' }"
      (viewChanged)="onToggle($event)"
      class="px-3 py-1 text-sm">
    </app-toggle-btns>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-12 gap-6 p-4 transition-colors duration-200">
    <!-- Left Section: Chart/Table (8/12) -->
    <div class="lg:col-span-8">
      <!-- Summary Section -->
      <div class="mb-4">
        <h2 class="text-lg text-slate-600 dark:text-slate-400 mb-2">{{ selectedLabel }}</h2>
        <div class="flex items-center gap-6">
          <div class="flex items-center gap-2">
            <span class="w-2 h-2 rounded-full bg-[#AD46FF] inline-block"></span>
            <span class="text-sm text-slate-600 dark:text-slate-400">Current: 
              <span class="font-semibold text-slate-800 dark:text-slate-100">{{ currentTotal }}</span>
            </span>
          </div>
          
          @if (previousTotal > 0) {
            <div class="flex items-center gap-2">
              <span class="w-2 h-2 rounded-full bg-slate-400 inline-block"></span>
              <span class="text-sm text-slate-600 dark:text-slate-400">Previous: 
                <span class="font-semibold text-slate-800 dark:text-slate-100">{{ previousTotal }}</span>
              </span>
            </div>
          }
        </div>
      </div>

      <!-- Chart/Table View -->
      <div class="min-h-[300px]">
        @if (view === 'chart') {
          <div class="h-[300px]">
            <app-line-chart
              [data1]="chartData"
              [data2]="previousChartData"
              [valueKey]="'value'"
              [unit]="dateRange.unit || 'day'"
              [showYAxis]="false"
              [showYAxisGrid]="false"
              [showYAxisPath]="true"
              [curveType]="'curveLinear'">
            </app-line-chart>
          </div>
        }

        @if (view === 'table') {
          <div class="overflow-hidden h-[400px]">
            <app-scroll-table
              [tableData]="tableData"
              [previousData]="previousTableData"
              [headers]="tableHeaders"
              [showHeading]="false">
            </app-scroll-table>
          </div>
        }
      </div>
    </div>

    <!-- Right Section: Selector (4/12) -->
    <div class="lg:col-span-4">
      <div class="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4">
        <app-selection
          [mode]="'single'"
          [options]="selectorOptions"
          [name]="dataType === 'stage' ? 'stageSelector' : 'phaseSelector'"
          [label]="'Select ' + (dataType === 'stage' ? 'Stage' : 'Phase')"
          [size]="'sm'"
          [variant]="'default'"
          [orientation]="'vertical'"
          [fullWidth]="true"
          [(ngModel)]="selectedValue"
          (valueChange)="onSelectionChange($event)"
          containerClass="max-h-[450px] overflow-y-auto pr-2">
        </app-selection>
      </div>
    </div>
  </div>
    @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
</div>

